import api from "./api";

const VehicleServiceService = {
  // ✅ CREATE a new vehicle service
  save: async (data) => {
    const response = await api.post("/vehicleService/save", data);
    return response.data;
  },

  // ✅ GET all vehicle services
  getAll: async () => {
    const response = await api.get("/vehicleService/getAll");
    return response.data;
  },

  // ✅ GET only active vehicle services
  getActive: async () => {
    const response = await api.get("/vehicleService/active/list");
    return response.data;
  },


  getById: async (id) => {
    const res = await api.get(`/vehicleService/getById/${id}`);
    return res.data;
  },

  // getByCompanyId: async (companyId) => {
  //   const res = await api.get(`/vehicleService/getBycompany/${companyId}`);
  //   return res.data;
  // },

  getByCompanyId: async (companyId, pageNumber, noOfRows, search = "") => {
    const res = await api.get(
      `/vehicleService/getBycompany/${companyId}?pageNumber=${pageNumber}&noOfRows=${noOfRows}&search=${search}`
    );
    return res.data;
  },
  // ✅ UPDATE vehicle service by ID
  update: async (id, data) => {
    const response = await api.put(`/vehicleService/${id}`, data);
    return response.data;
  },

  // ✅ HARD DELETE (permanent delete)
  delete: async (id) => {
    const response = await api.delete(`/vehicleService/${id}`);
    return response.data;
  },

  // ✅ TOGGLE STATUS (Active <-> Inactive)
  updateStatus: async (id) => {
    const response = await api.put(`/vehicleService/updatestatus/${id}`);
    return response.data;
  },


  exportVehicleService: async (companyId) => {
    const response = await api.get(`/vehicleService/export?companyId=${companyId}`);
    return response.data;
  },
};

export default VehicleServiceService;
